export enum SupportType {
  BOX_MEAT_60_40_20 = 'BOX_MEAT_60_40_20',
  HALF_PALLET_60_80 = 'HALF_PALLET_60_80',
  PALLET_DOSS_100_120 = 'PALLET_DOSS_100_120',
  PALLET_HALF_80_120 = 'PALLET_HALF_80_120',
  PALLET_LIGHT_60_100 = 'PALLET_LIGHT_60_100',
  PALLET_LIGHT_100_120 = 'PALLET_LIGHT_100_120',
  PALLET_LIGHT_80_120 = 'PALLET_LIGHT_80_120',
  TICKET = 'TICKET',
  PALLET = 'PALLET',
  CONTAINER_EUR = 'CONTAINER_EUR',
  BLUE_BOX = 'BLUE_BOX',
  PLASTIC_BELT = 'PLASTIC_BELT',
  BOX_IFCO = 'BOX_IFCO',
  CC_TAG5_ROLL = 'CC_TAG5_ROLL',
  CC_SHELF = 'CC_SHELF',
  NON_CC_SHELF = 'NON_CC_SHELF',
  ROLLS_SUPPORT = 'ROLLS_SUPPORT',
  SMALL_METALLIC_RISER = 'SMALL_METALLIC_RISER',
  FLORISTRY_BUCKETS_SIZE_1_SQUARE = 'FLORISTRY_BUCKETS_SIZE_1_SQUARE',
  PALLET_PLASTIC_120_120 = 'PALLET_PLASTIC_120_120',
  BUTCHER_ROLL = 'BUTCHER_ROLL',
  HALF_PALLET_SOLE_60_80 = 'HALF_PALLET_SOLE_60_80',
  PALLET_DOSS_METAL_100_120 = 'PALLET_DOSS_METAL_100_120',
  PALLET_LIGHT_60_80 = 'PALLET_LIGHT_60_80',
  UNIT_CARDBOARD_WASTE = 'UNIT_CARDBOARD_WASTE',
  UNIT_PLASTIC_WASTE = 'UNIT_PLASTIC_WASTE',
  UNIT_PET = 'UNIT_PET',
  CC_PLATE_ROLL = 'CC_PLATE_ROLL',
  DC_ROLL_OTHER = 'DC_ROLL_OTHER',
  LARGE_METALLIC_RISER = 'LARGE_METALLIC_RISER',
  FLORISTRY_BUCKETS_SIZE_2_ROUND = 'FLORISTRY_BUCKETS_SIZE_2_ROUND',
  RED_BOX = 'RED_BOX',
  BASE = 'BASE',
  FIL = 'FIL',
  PLASTIC_PALLET = 'PLASTIC_PALLET',
  HALF_PLASTIC_PALLET = 'HALF_PLASTIC_PALLET',
  COVER = 'COVER',
  COMBI = 'COMBI',
  CHEP_PALLET_80_120 = 'CHEP_PALLET_80_120',
  IPP_PALLET_80_120 = 'IPP_PALLET_80_120',
  HALF_CHEP_PALLET_80_60 = 'HALF_CHEP_PALLET_80_60',
  HALF_IPP_PALLET_80_60 = 'HALF_IPP_PALLET_80_60',
  PLASTIC_BOX_IFCO = 'PLASTIC_BOX_IFCO',
  A_FRAME_PALLET_80_120 = 'A_FRAME_PALLET_80_120',
  DOUBLE_WIDTH_PALLET_120_160 = 'DOUBLE_WIDTH_PALLET_120_160',
  SIDE_PALLET_STILLAGE_100_120 = 'SIDE_PALLET_STILLAGE_100_120',
  BAR_PALLET_STILLAGE_80_110 = 'BAR_PALLET_STILLAGE_80_110',
  PALLET_120_240 = 'PALLET_120_240',
  OTHER = 'OTHER',
  DOUBLE_LENGTH_PALLET_80_240 = 'DOUBLE_LENGTH_PALLET_80_240',
  SIDE_PALLET_STILLAGE_80_120 = 'SIDE_PALLET_STILLAGE_80_120',
  BAR_PALLET_STILLAGE_80_120 = 'BAR_PALLET_STILLAGE_80_120',
  DOUBLE_BAR_PALLET_STILLAGE_120_160 = 'DOUBLE_BAR_PALLET_STILLAGE_120_160',
  LEAN_PALLET_80_150 = 'LEAN_PALLET_80_150',
  QUARTER_PALLET_40_60 = 'QUARTER_PALLET_40_60',
  ROLL_CONTAINER_70_80 = 'ROLL_CONTAINER_70_80',
  PHYTOSANITARY_DOUBLE_WIDTH_PALLET_120_160 = 'PHYTOSANITARY_DOUBLE_WIDTH_PALLET_120_160',
  PHYTOSANITARY_A_FRAME_PALLET_80_120 = 'PHYTOSANITARY_A_FRAME_PALLET_80_120',
  PHYTOSANITARY_DOUBLE_A_FRAME_PALLET_80_240 = 'PHYTOSANITARY_DOUBLE_A_FRAME_PALLET_80_240',
  PHYTOSANITARY_DOUBLE_LENGTH_PALLET_80_240 = 'PHYTOSANITARY_DOUBLE_LENGTH_PALLET_80_240',
  PHYTOSANITARY_PALLET_120_240 = 'PHYTOSANITARY_PALLET_120_240',
  DOUBLE_PALLET_STILLAGE_120_240 = 'DOUBLE_PALLET_STILLAGE_120_240',
  DOUBLE_A_FRAME_PALLET_80_240 = 'DOUBLE_A_FRAME_PALLET_80_240',
  PALLET_STILLAGE_120_80 = 'PALLET_STILLAGE_120_80',
  PALLET_STILLAGE_80_120 = 'PALLET_STILLAGE_80_120',
  ALL = 'ALL'
}










